export var ServiceType;
(function (ServiceType) {
    ServiceType["UNKNOWN_SERVICE_TYPE"] = "UNKNOWN_SERVICE_TYPE";
    /** Appointment-based service. */
    ServiceType["APPOINTMENT"] = "APPOINTMENT";
    /** Class service. */
    ServiceType["CLASS"] = "CLASS";
    /** Course service. */
    ServiceType["COURSE"] = "COURSE";
})(ServiceType || (ServiceType = {}));
export var RateType;
(function (RateType) {
    /** Unknown rate type. */
    RateType["UNKNOWN_RATE_TYPE"] = "UNKNOWN_RATE_TYPE";
    /** The service has a fixed price. */
    RateType["FIXED"] = "FIXED";
    /** The service has a custom price, expressed as a price description. */
    RateType["CUSTOM"] = "CUSTOM";
    /** This service is offered with a set of different prices based on different terms. */
    RateType["VARIED"] = "VARIED";
    /** This service is offered free of charge. */
    RateType["NO_FEE"] = "NO_FEE";
})(RateType || (RateType = {}));
export var AddOnPaymentOptions;
(function (AddOnPaymentOptions) {
    /** There is no information about how customers are required to pay for add-ons when the booking is paid for with a pricing plan. */
    AddOnPaymentOptions["UNKNOWN_ADD_ON_PAYMENT_OPTIONS"] = "UNKNOWN_ADD_ON_PAYMENT_OPTIONS";
    /** Customers are required to pay online for add-ons when the booking is paid for with a pricing plan. */
    AddOnPaymentOptions["ONLINE"] = "ONLINE";
    /** Customers are required to pay in person for add-ons when the booking is paid for with a pricing plan. */
    AddOnPaymentOptions["IN_PERSON"] = "IN_PERSON";
})(AddOnPaymentOptions || (AddOnPaymentOptions = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNKNOWN_LOCATION_TYPE"] = "UNKNOWN_LOCATION_TYPE";
    /** Location set by the business that is not a standard business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction). */
    LocationType["CUSTOM"] = "CUSTOM";
    /** Business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction). */
    LocationType["BUSINESS"] = "BUSINESS";
    /**
     * The customer specifies any address when booking. Available only for
     * appointment-based services.
     */
    LocationType["CUSTOMER"] = "CUSTOMER";
})(LocationType || (LocationType = {}));
/** Order for ranking-based staff selection. */
export var RankingOrder;
(function (RankingOrder) {
    RankingOrder["UNKNOWN_RANKING_ORDER"] = "UNKNOWN_RANKING_ORDER";
    /** Staff members with lower priority values are selected first. */
    RankingOrder["LOWEST_TO_HIGHEST"] = "LOWEST_TO_HIGHEST";
    /** Staff members with higher priority values are selected first. */
    RankingOrder["HIGHEST_TO_LOWEST"] = "HIGHEST_TO_LOWEST";
})(RankingOrder || (RankingOrder = {}));
/** Method used to sort and select staff members. */
export var SortingMethodType;
(function (SortingMethodType) {
    SortingMethodType["UNKNOWN_SORTING_METHOD_TYPE"] = "UNKNOWN_SORTING_METHOD_TYPE";
    /** Staff members are selected randomly from available options. */
    SortingMethodType["RANDOM"] = "RANDOM";
    /** Staff members are selected based on their priority ranking. */
    SortingMethodType["RANKING"] = "RANKING";
    /**
     * Staff members are selected using a custom implementation provided by SortStaffSPI.
     * This allows third-party apps to implement custom staff sorting logic.
     */
    SortingMethodType["CUSTOM"] = "CUSTOM";
})(SortingMethodType || (SortingMethodType = {}));
export var Timing;
(function (Timing) {
    Timing["UNKNOWN_TIMING"] = "UNKNOWN_TIMING";
    /** Send form after booking. */
    Timing["AFTER_BOOKING"] = "AFTER_BOOKING";
    /** Show form during booking flow. */
    Timing["BEFORE_BOOKING"] = "BEFORE_BOOKING";
})(Timing || (Timing = {}));
/** Requirement for completing the intake form. */
export var CompletionRequirement;
(function (CompletionRequirement) {
    CompletionRequirement["UNKNOWN_COMPLETION_REQUIREMENT"] = "UNKNOWN_COMPLETION_REQUIREMENT";
    /** Form completion is optional and can be skipped entirely. */
    CompletionRequirement["OPTIONAL"] = "OPTIONAL";
    /**
     * Form must be completed before the booking can be finalized.
     * can used only if timing is BEFORE_BOOKING.
     */
    CompletionRequirement["REQUIRED_BEFORE_BOOKING"] = "REQUIRED_BEFORE_BOOKING";
})(CompletionRequirement || (CompletionRequirement = {}));
export var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN_TAXABLE_ADDRESS_TYPE"] = "UNKNOWN_TAXABLE_ADDRESS_TYPE";
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    TaxableAddressType["BILLING"] = "BILLING";
})(TaxableAddressType || (TaxableAddressType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var RequestedFields;
(function (RequestedFields) {
    /** Unknown requested field. */
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** When passed, `service.staff_members` is returned. */
    RequestedFields["STAFF_MEMBER_DETAILS"] = "STAFF_MEMBER_DETAILS";
    /** When passed, `service.service_resources.resource_type.name` is returned. */
    RequestedFields["RESOURCE_TYPE_DETAILS"] = "RESOURCE_TYPE_DETAILS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    SortType["COUNT"] = "COUNT";
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["DESC"] = "DESC";
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    MissingValues["EXCLUDE"] = "EXCLUDE";
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Total number of distinct values. */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value. */
    ScalarType["MIN"] = "MIN";
    /** Maximum value. */
    ScalarType["MAX"] = "MAX";
    /** Sum of values. */
    ScalarType["SUM"] = "SUM";
    /** Average of values. */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
    NestedAggregationType["VALUE"] = "VALUE";
    /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
    NestedAggregationType["RANGE"] = "RANGE";
    /** Calculates a single numerical value from a dataset, summarizing the dataset into 1 key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var DateHistogramAggregationInterval;
(function (DateHistogramAggregationInterval) {
    /** Unknown interval. */
    DateHistogramAggregationInterval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    /** Yearly interval. */
    DateHistogramAggregationInterval["YEAR"] = "YEAR";
    /** Monthly interval. */
    DateHistogramAggregationInterval["MONTH"] = "MONTH";
    /** Weekly interval. */
    DateHistogramAggregationInterval["WEEK"] = "WEEK";
    /** Daily interval. */
    DateHistogramAggregationInterval["DAY"] = "DAY";
    /** Hourly interval. */
    DateHistogramAggregationInterval["HOUR"] = "HOUR";
    /** Minute interval. */
    DateHistogramAggregationInterval["MINUTE"] = "MINUTE";
    /** Second interval. */
    DateHistogramAggregationInterval["SECOND"] = "SECOND";
})(DateHistogramAggregationInterval || (DateHistogramAggregationInterval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
    AggregationType["VALUE"] = "VALUE";
    /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
    AggregationType["RANGE"] = "RANGE";
    /** Calculates a single numerical value from a dataset, summarizing the dataset into 1 key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
    AggregationType["SCALAR"] = "SCALAR";
    /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Flattened list of aggregations, where each aggregation is nested within previous 1. */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** At least 1 of the search terms must be present. */
    Mode["OR"] = "OR";
    /** All search terms must be present. */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var QueryBookingFormsRequestRequestedFields;
(function (QueryBookingFormsRequestRequestedFields) {
    /** Unknown requested conditional field. */
    QueryBookingFormsRequestRequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Whether to return the site's default booking form. */
    QueryBookingFormsRequestRequestedFields["DEFAULT_BOOKING_FORM"] = "DEFAULT_BOOKING_FORM";
})(QueryBookingFormsRequestRequestedFields || (QueryBookingFormsRequestRequestedFields = {}));
export var Action;
(function (Action) {
    Action["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    /** Retain all future sessions at their current location. This is the default. */
    Action["KEEP_AT_CURRENT_LOCATION"] = "KEEP_AT_CURRENT_LOCATION";
    /** Move future events to a new location. */
    Action["MOVE_TO_LOCATION"] = "MOVE_TO_LOCATION";
    /**
     * Cancel all future events at the removed location.
     * Currently not supported.
     */
    Action["DELETE"] = "DELETE";
})(Action || (Action = {}));
export var InvalidSlugError;
(function (InvalidSlugError) {
    /** Unknown slug error. */
    InvalidSlugError["UNKNOWN_SLUG_ERROR"] = "UNKNOWN_SLUG_ERROR";
    /** Slug contains illegal characters. */
    InvalidSlugError["SLUG_CONTAINS_ILLEGAL_CHARACTERS"] = "SLUG_CONTAINS_ILLEGAL_CHARACTERS";
    /** Slug is already associated with another service. */
    InvalidSlugError["SLUG_ALREADY_EXISTS"] = "SLUG_ALREADY_EXISTS";
})(InvalidSlugError || (InvalidSlugError = {}));
export var CloneErrors;
(function (CloneErrors) {
    /** Unknown error. */
    CloneErrors["UNKNOWN_CLONE_ERROR"] = "UNKNOWN_CLONE_ERROR";
    /**
     * Failed to clone sessions belonging to the original service's active
     * schedule.
     */
    CloneErrors["SESSIONS"] = "SESSIONS";
    /** Failed to clone the original service's [options and variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction). */
    CloneErrors["OPTIONS_AND_VARIANTS"] = "OPTIONS_AND_VARIANTS";
    /** Failed to clone the original service's *booking form*. */
    CloneErrors["FORM"] = "FORM";
    /** Failed to add [pricing plans](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/introduction) as supported payment methods for the cloned service. */
    CloneErrors["PRICING_PLANS"] = "PRICING_PLANS";
})(CloneErrors || (CloneErrors = {}));
export var Status;
(function (Status) {
    /** The category was created. */
    Status["CREATED"] = "CREATED";
    /** The category was deleted. */
    Status["DELETED"] = "DELETED";
})(Status || (Status = {}));
export var Event;
(function (Event) {
    /** Category was updated. */
    Event["Updated"] = "Updated";
    /** Category was deleted. */
    Event["Deleted"] = "Deleted";
    /** Category was created. */
    Event["Created"] = "Created";
})(Event || (Event = {}));
export var BenefitType;
(function (BenefitType) {
    /** Should never be used */
    BenefitType["UNDEFINED"] = "UNDEFINED";
    /** Limited benefit type */
    BenefitType["LIMITED"] = "LIMITED";
    /** Unlimited benefit type */
    BenefitType["UNLIMITED"] = "UNLIMITED";
})(BenefitType || (BenefitType = {}));
export var BenefitNotificationEvent;
(function (BenefitNotificationEvent) {
    BenefitNotificationEvent["Updated"] = "Updated";
    BenefitNotificationEvent["Deleted"] = "Deleted";
    BenefitNotificationEvent["Created"] = "Created";
})(BenefitNotificationEvent || (BenefitNotificationEvent = {}));
export var CrudType;
(function (CrudType) {
    CrudType["INVALID_CRUD_TYPE"] = "INVALID_CRUD_TYPE";
    CrudType["CREATE"] = "CREATE";
    CrudType["UPDATE"] = "UPDATE";
    CrudType["DELETE"] = "DELETE";
    /** Unfortunately this action is used by hibernate save in wix-war */
    CrudType["CREATE_OR_UPDATE"] = "CREATE_OR_UPDATE";
})(CrudType || (CrudType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
//# sourceMappingURL=types.impl.js.map